import {
  SHOP_PRODUCT_REQUEST,
  SHOP_PRODUCT_SUCCESS,
  // SHOP_PRODUCT_FAILURE,
  SHOP_PRODUCT_CLEAR,
} from 'app/common/actions/shop/catalog/product';


const defaultState = {
  data: {},
  loading: true,
};

const product = (state = defaultState, { type, payload }) => {
  switch (type) {
    case SHOP_PRODUCT_REQUEST: {
      return { ...state, loading: true };
    }

    case SHOP_PRODUCT_SUCCESS: {
      return { ...state, loading: false, data: payload };
    }

    case SHOP_PRODUCT_CLEAR: {
      return defaultState;
    }

    default:
  }
  return state;
};

export default product;
